import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-p-4 sm:tw-p-6" }
const _hoisted_2 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-3 sm:tw-p-4" }
const _hoisted_3 = { class: "tw-mb-3" }
const _hoisted_4 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_5 = { class: "tw-overflow-x-auto" }
const _hoisted_6 = { class: "tw-min-w-full tw-border-separate tw-border-spacing-0 tw-text-left" }
const _hoisted_7 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_10 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_11 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_12 = { class: "tw-px-3 tw-py-3 tw-text-sm" }
const _hoisted_13 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_14 = { class: "tw-px-3 tw-py-3 tw-text-right" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4" }
const _hoisted_17 = { class: "md:tw-col-span-2" }
const _hoisted_18 = { class: "md:tw-col-span-2" }
const _hoisted_19 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_20 = { class: "md:tw-col-span-2" }
const _hoisted_21 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_22 = { class: "md:tw-col-span-2" }
const _hoisted_23 = { class: "tw-mt-1" }
const _hoisted_24 = {
  key: 0,
  class: "tw-mt-4 tw-text-sm tw-text-rose-600"
}
const _hoisted_25 = { class: "tw-mt-6 tw-flex tw-justify-end tw-gap-2" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["disabled"]

import { computed, reactive, ref } from 'vue';
import { useApolloClient, useQuery } from '@vue/apollo-composable';
import DriversQuery from '../../gql/orders/Drivers.gql';
import TrucksQuery from '../../gql/drivers/Trucks.gql';
import CreateDriverMutation from '../../gql/drivers/CreateDriver.gql';
import UpdateDriverMutation from '../../gql/drivers/UpdateDriver.gql';

import Modal from '@/components/core/Modal/Modal.vue';
import FilterableDropdown from '../core/FilterableDropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileDriversTab',
  setup(__props) {

const apollo = useApolloClient();

const { result, refetch } = useQuery(DriversQuery);

const trucksQuery = useQuery(TrucksQuery);

const drivers = computed(() => {
  const user = result.value?.user;
  return user?.drivers || [];
});

const trucks = computed(() => trucksQuery.result.value?.trucks || []);

const showActiveOnly = ref(true);
const filteredDrivers = computed(() => {
  const list = drivers.value || [];
  return showActiveOnly.value ? list.filter((d: any) => d.isActive) : list;
});

const isModalOpen = ref(false);
const modalMode = ref<'create' | 'edit'>('create');
const editingDriverId = ref<number | null>(null);
const isSaving = ref(false);
const formError = ref<string | null>(null);

const form = reactive({
  fullName: '',
  phoneNumber: '',
  email: '',
  isOwnerOperator: false,
  isActive: true,
  truckId: null as number | null,
});

function resetForm() {
  form.fullName = '';
  form.phoneNumber = '';
  form.email = '';
  form.isOwnerOperator = false;
  form.isActive = true;
  form.truckId = null;
  formError.value = null;
}

function openCreate() {
  modalMode.value = 'create';
  editingDriverId.value = null;
  resetForm();
  isModalOpen.value = true;
}

function openEdit(driver: any) {
  modalMode.value = 'edit';
  editingDriverId.value = parseInt(String(driver.id), 10);
  form.fullName = driver.fullName || driver.name || '';
  form.phoneNumber = driver.phoneNumber || '';
  form.email = driver.email || '';
  form.isOwnerOperator = !!driver.isOwnerOperator;
  form.isActive = driver.isActive !== false;
  form.truckId = driver.truck && driver.truck.length > 0 ? driver.truck[0].id : null;
  formError.value = null;
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

function createdDriver() {
  refetch();
}

function refreshUserData() {
  refetch();
}

async function submit() {
  if (isSaving.value) return;
  formError.value = null;

  if (!form.fullName || !form.phoneNumber) {
    formError.value = 'Driver name and phone number are required.';
    return;
  }

  isSaving.value = true;
  try {
    const normalizedTruckId =
      form.truckId === null || form.truckId === undefined || form.truckId === ''
        ? null
        : Number.parseInt(String(form.truckId), 10);

    if (modalMode.value === 'create') {
      await apollo.client.mutate({
        mutation: CreateDriverMutation,
        variables: {
          module: 'CONTRAK',
          phone: form.phoneNumber,
          name: form.fullName,
          email: form.email || null,
        },
      });
    } else {
      await apollo.client.mutate({
        mutation: UpdateDriverMutation,
        variables: {
          module: 'CONTRAK',
          id: editingDriverId.value,
          phone: form.phoneNumber,
          name: form.fullName,
          email: form.email || null,
          isOwnerOperator: form.isOwnerOperator,
          isActive: form.isActive,
          truckId: Number.isNaN(normalizedTruckId as number) ? null : normalizedTruckId,
        },
      });
    }

    await refetch();
    closeModal();
  } catch (e: any) {
    formError.value = e?.message || String(e);
  } finally {
    isSaving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tw-text-left" }, [
        _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Drivers"),
        _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Manage your driver roster.")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
        onClick: openCreate
      }, " Add driver ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "tw-h-4 tw-w-4",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showActiveOnly).value = $event))
          }, null, 512), [
            [_vModelCheckbox, showActiveOnly.value]
          ]),
          _cache[9] || (_cache[9] = _createTextVNode(" Show active drivers only ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Name"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Phone"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Email"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Status"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Truck #"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" })
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDrivers.value, (driver) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: driver.id,
                class: "tw-cursor-pointer hover:tw-bg-slate-50/70",
                onClick: ($event: any) => (openEdit(driver))
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(driver.fullName || driver.name), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(driver.phoneNumber), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(driver.email || '—'), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold", driver.isActive ? 'tw-bg-emerald-100 tw-text-emerald-900' : 'tw-bg-slate-200 tw-text-slate-800'])
                  }, _toDisplayString(driver.isActive ? 'Active' : 'Inactive'), 3)
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString((driver.truck && driver.truck.length > 0 && driver.truck[0].truckNumber) || '—'), 1),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-800 hover:tw-bg-white",
                    onClick: _withModifiers(($event: any) => (openEdit(driver)), ["stop"])
                  }, " Edit ", 8, _hoisted_15)
                ])
              ], 8, _hoisted_8))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(Modal, {
      isOpen: isModalOpen.value,
      "onUpdate:isOpen": _cache[7] || (_cache[7] = ($event: any) => ((isModalOpen).value = $event)),
      modalId: "driver-modal",
      title: modalMode.value === 'create' ? 'Add Driver' : 'Edit Driver',
      maxWidth: "2xl"
    }, {
      content: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Driver Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.fullName) = $event)),
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.fullName]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Driver Phone #", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.phoneNumber) = $event)),
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.phoneNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Driver Email", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.email) = $event)),
              type: "email",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "tw-h-4 tw-w-4",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.isOwnerOperator) = $event))
              }, null, 512), [
                [_vModelCheckbox, form.isOwnerOperator]
              ]),
              _cache[14] || (_cache[14] = _createTextVNode(" Is Owner Operator? ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "tw-h-4 tw-w-4",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.isActive) = $event))
              }, null, 512), [
                [_vModelCheckbox, form.isActive]
              ]),
              _cache[15] || (_cache[15] = _createTextVNode(" Is Active? ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Truck", -1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(FilterableDropdown, {
                modelValue: form.truckId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.truckId) = $event)),
                options: trucks.value,
                label: "truckNumber",
                reduce: (truck) => truck.id,
                class: "tw-w-full",
                components: { OpenIndicator: null, Deselect: null }
              }, null, 8, ["modelValue", "options", "reduce"])
            ])
          ])
        ]),
        (formError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(formError.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-800 hover:tw-bg-slate-50",
            onClick: close
          }, " Cancel ", 8, _hoisted_26),
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60",
            disabled: isSaving.value,
            onClick: submit
          }, [
            (isSaving.value)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "circle-notch",
                  spin: "",
                  class: "tw-h-4 tw-w-4"
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: "check",
                  class: "tw-h-4 tw-w-4"
                })),
            _cache[17] || (_cache[17] = _createTextVNode(" Save ", -1))
          ], 8, _hoisted_27)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "title"])
  ]))
}
}

})